/*********
 Header Sticky
 **********/

if (document.querySelector("#shopify-section-theme-header-v2")) {
    const stickyObserver = new IntersectionObserver(
        ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
        {threshold: [1]}
    );
    stickyObserver.observe(document.querySelector("#shopify-section-theme-header-v2"))
}

/*********
 Desktop Dropdown Menu
 **********/
document.querySelectorAll('button.headerNavTitle').forEach(el => {
    el.addEventListener('click', function () {
        let parent = this.closest('.headerNavMenu');
        if (parent.classList.contains('active')) {
            parent.classList.toggle('active');
            document.querySelector("#header").classList.remove("menuOpen");
        } else {
            document.querySelectorAll('.headerNavMenu.active').forEach(el => {
                el.classList.remove('active');
            });
            document.querySelector("#header").classList.add("menuOpen");
            parent.classList.toggle('active');
        }
    })
})

// Backdrop
document.querySelector("#header").addEventListener("click", function (event) {
    if (event.target.id === "headerBackdrop") {
        if (document.querySelector(".headerNavMenu.active")) {
            document.querySelector(".headerNavMenu.active").classList.remove("active");
            document.querySelector("#header").classList.remove("menuOpen");
        }
    }
})

// closing menu on escape and focus on main content
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        document.querySelectorAll('.headerNavMenu')?.forEach(el => {
            el.classList.remove('active');
        })
        document.querySelector("#header").classList.remove("menuOpen");
        document.querySelector('.mainContentFocus')?.focus();
    }
});

/**************
 Mobile Nav
 ***************/

const slider = document.querySelector("#slider");
const body = document.querySelector("body");
const open = document.querySelector("#headerMenu");
const close = document.querySelector("#sliderClose");

// open nav
function openNav() {
    slider.showModal();
    document.querySelector("body").classList.add("noScroll");
    open.classList.add("open");
    close.classList.add("open");
    // set padding on top of slider, pushes menu under header
    const headerBottom = document.querySelector('#header').getBoundingClientRect().bottom;
    slider.style.paddingTop = `${headerBottom}px`
}

// close nav
function closeNav() {
    slider.close();
}

// slider dialog close
slider.addEventListener('close', () => {
    document.querySelector("body").classList.remove("noScroll");
    open.classList.remove("open");
    close.classList.remove("open");
})

// slider dialog close
slider.addEventListener('click', function (e) {
    if (e.target === this) closeNav();
})

// open nav event listener
open.addEventListener("click", openNav);

//close nav event listener
close.addEventListener("click", closeNav);

/**************
 Mobile Nav Dropdowns
 ***************/

document.querySelectorAll('.sliderV1ProductsItemTop').forEach(el => {
    el.addEventListener('click', function () {
        let parent = this.closest('.sliderV1ProductsItem');
        parent.classList.toggle('active');
    })
});

// setup Dropdowns
document.querySelectorAll(".sliderContentV3DropdownTop")?.forEach(element => {
    element.addEventListener("click", function () {
        if (this.classList.contains('solo')) {
            return;
        }
        this.classList.toggle("active");
    });
});

/*******************
 Footer Contact
 *******************/

// on click open chat bot
document.querySelector("#footerNavLinksContact")?.addEventListener("click", function (e) {
    e.preventDefault();
    window.bik_widget.open();
});